import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WebApiService } from 'src/app/shared';
import { environment } from 'src/environments/environment';
import { CsLocationSetup, GridConnectionSection, GridProvider, InstallationActivity, InstallationSection, InstallationDescription } from './cs-installation-section.model';

@Injectable({
  providedIn: 'root'
})
export class CsInstallationSectionService extends WebApiService {
  private readonly gridProvidersUrl = `${this.catalogUrl}/gridproviders`;
  private readonly installationActivitiesUrl = `${this.catalogUrl}/installationactivities`;
  private readonly csLocationPlanningUrl = 'cslocationplanning';
  private readonly gridConnectionUrl = 'gridconnection';
  private readonly csInstallationUrl = 'csinstallation';
  private readonly installationDescriptionUrl = 'installationdescription';

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar) {
    super(http, snackBar);
  }

  public getGridProviders(): Observable<ReadonlyArray<GridProvider>> {
    return this.http.get<GridProvider[]>(`${this.gridProvidersUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public getInstallationActivities(): Observable<ReadonlyArray<InstallationActivity>> {
    return this.http.get<InstallationActivity[]>(`${this.installationActivitiesUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public addCsLocationSetup(projectId: Guid, newCsLocationSetup: CsLocationSetup): Observable<CsLocationSetup> {
    return this.post(projectId, this.csLocationPlanningUrl, newCsLocationSetup);
  }

  public getCsLocationSetup(projectId: Guid): Observable<CsLocationSetup> {
    return this.get(projectId, this.csLocationPlanningUrl);
  }

  public updateCsLocationSetup(projectId: Guid, updatedCsLocationSetup: CsLocationSetup): Observable<CsLocationSetup> {
    return this.put(projectId, this.csLocationPlanningUrl, updatedCsLocationSetup);
  }

  public deleteCsLocationSetup(projectId: Guid): Observable<CsLocationSetup> {
    return this.delete(projectId, this.csLocationPlanningUrl);
  }


  public addGridConnectionSection(projectId: Guid, newGridConnectionSection: GridConnectionSection): Observable<GridConnectionSection> {
    return this.post(projectId, this.gridConnectionUrl, newGridConnectionSection);
  }

  public getGridConnectionSection(projectId: Guid): Observable<GridConnectionSection> {
    return this.get(projectId, this.gridConnectionUrl);
  }

  public updateGridConnectionSection(projectId: Guid, updatedGridConnectionSection: GridConnectionSection)
  : Observable<GridConnectionSection> {
    return this.put(projectId, this.gridConnectionUrl, updatedGridConnectionSection);
  }

  public deleteGridConnectionSection(projectId: Guid): Observable<GridConnectionSection> {
    return this.delete(projectId, this.gridConnectionUrl);
  }


  public addInstallationSection(projectId: Guid, newInstallationSection: InstallationSection): Observable<InstallationSection> {
    return this.post(projectId, this.csInstallationUrl, newInstallationSection);
  }

  public getInstallationSection(projectId: Guid): Observable<InstallationSection> {
    return this.get(projectId, this.csInstallationUrl);
  }

  public updateInstallationSection(projectId: Guid, updatedInstallationSection: InstallationSection)
  : Observable<InstallationSection> {
    return this.put(projectId, this.csInstallationUrl, updatedInstallationSection);
  }

  public deleteInstallationSection(projectId: Guid): Observable<InstallationSection> {
    return this.delete(projectId, this.csInstallationUrl);
  }


  public addInstallationDescription(projectId: Guid, newInstallationDescription: InstallationDescription): Observable<InstallationDescription> {
    return this.post(projectId, this.installationDescriptionUrl, newInstallationDescription);
  }

  public getInstallationDescription(projectId: Guid): Observable<InstallationDescription> {
    return this.get(projectId, this.installationDescriptionUrl);
  }

  public updateInstallationDescription(projectId: Guid, updatedInstallationDescription: InstallationDescription)
  : Observable<InstallationDescription> {
    return this.put(projectId, this.installationDescriptionUrl, updatedInstallationDescription);
  }

  public deleteInstallationDescription(projectId: Guid): Observable<InstallationDescription> {
    return this.delete(projectId, this.installationDescriptionUrl);
  }
}
